import axios from "axios"

export function getDealerRewardList (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(`/distributor/admin/api/v1/dealers/${parameters.id}/reward`, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      filter: {
        search: parameters.filter.search,
        from_date: parameters.filter.from_date,
        to_date: parameters.filter.to_date,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};